import { ReactNode } from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

import colors from 'config/colors';
import { isWeb } from 'util/helpers';
import { Text } from 'components';

import type { MaterialCommunityIconName } from 'types/icons';

type HeaderFieldProps = {
  iconName?: MaterialCommunityIconName;
  value?: ReactNode;
  style?: ViewStyle;
};

export const HeaderField = ({ iconName, value, style }: HeaderFieldProps) => {
  return (
    <View style={[styles.field, style]}>
      {Boolean(iconName) && (
        <MaterialCommunityIcons name={iconName} color="white" size={16} />
      )}
      {Boolean(value) && (
        <Text style={styles.fieldLabel} color="white" font="medium" size={16}>
          {value}
        </Text>
      )}
    </View>
  );
};

type SubHeaderFieldProps = {
  label?: ReactNode;
  value?: ReactNode;
  style?: ViewStyle;
};

export const SubHeaderField = ({
  label,
  value,
  style,
}: SubHeaderFieldProps) => {
  return (
    <View
      style={[
        styles.field,
        {
          flexDirection: 'column',
        },
        style,
      ]}
    >
      {Boolean(label) && (
        <Text
          style={styles.fieldLabel}
          color={colors.lightGray}
          font="medium"
          size={14}
        >
          {label}:
        </Text>
      )}
      {Boolean(value) && (
        <Text
          style={styles.fieldLabel}
          color="white"
          font="medium"
          size={14}
          numberOfLines={2}
        >
          {value}
        </Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  field: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexGrow: 1,
    flexShrink: 1,
    gap: 6,
  },
  fieldLabel: {
    flexWrap: 'wrap',
    ...(isWeb ? { wordBreak: 'break-all' } : {}),
  },
});
